import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REJECT_SALARY_PAYMENT_ASYNC,
    Actions.REJECT_SALARY_PAYMENT_SUCCESS,
    Actions.REJECT_SALARY_PAYMENT_FAIL,
    {}
  >,
): State => {
  switch (action.type) {
    case Actions.REJECT_SALARY_PAYMENT_ASYNC:
    case Actions.REJECT_SALARY_PAYMENT_FAIL:
    case Actions.REJECT_SALARY_PAYMENT_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }

    default:
      return state
  }
}
